const fileTypeExtractor = (filePath) => {
    const fileSplit = filePath?.split(".")
    const fileType = fileSplit[fileSplit.length - 1]

    return fileType
}

export default fileTypeExtractor